// extracted by mini-css-extract-plugin
export default {"btn-accept":"ActionStyles_btn-accept__+YFVI","btn-cancel":"ActionStyles_btn-cancel__eySV9","mr-12":"ActionStyles_mr-12__QIl4g"};